import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { SocialProofBar } from '../../components/SocialProofBar';
import { TrustBadges } from '../../components/TrustBadges';
export function KidsMartialArtsHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-2124">
      <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-2125">
        Kids Martial Arts
      </div>
      <div className="mb-8" data-id="element-2126">
        <SocialProofBar data-id="element-2127" />
      </div>
      <h1 className="text-5xl md:text-6xl text-white mb-6 leading-[1.1]" data-id="element-2128">
        Kids Martial Arts Classes Near Farmington Hills
      </h1>
      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-2129">
        Storm Taekwondo helps kids build confidence, discipline, focus and
        self-defense skills in a structured, supportive martial arts program.
        Mini Troopers ages 3–5, Kids Taekwondo ages 6+.
      </p>

      <ul className="flex flex-col gap-3 mb-10" data-id="element-2130">
        {['Respect and courtesy towards others', 'Goal setting and perseverance', 'Physical fitness and healthy habits', 'Self-defense and conflict avoidance'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-white text-lg" data-id="element-2131">
            <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0" data-id="element-2132" />
            <span data-id="element-2133">{item}</span>
          </li>)}
      </ul>

      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-2134">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-2135">
          Start With a Trial Class
        </Link>
        <a href="tel:517-220-0621" className="btn-secondary" data-id="element-2136">
          Call 517-220-0621
        </a>
      </div>
      <TrustBadges data-id="element-2137" />
    </div>;
}